import React from 'react';
import PropTypes from 'prop-types';
import util from "../../../../../../utils/es5Utils";
import _ from "underscore";

// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `iconclass` and `text` are valid
// Blockly toolbox attributes.
const Repeater = (props) => {
    const { blocks, context } = props;
    const widgets = util.widgetsOfType(context, "repeater");
    const newProps = { ...props, widgets };
    const childBlocks = _.map(blocks, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent {...newProps} key={blockKey}/>
    ));

    if (widgets.length > 0 && childBlocks.length > 0) {
        return (
            <category name='Repeater' id='repeater' iconclass='category with-icon-paths snap-icon-repeater_dual'>{/* NOSONAR */}
                <label text="Repeater"></label>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }

    return null;
};

Repeater.propTypes = {
    blocks: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
};

export default Repeater;
